import { Injectable } from '@angular/core';
import cepDefault, { cep as cepFn } from 'cep-promise';

const cep: typeof cepFn = cepFn ?? (cepDefault as unknown as typeof cepFn);

@Injectable({
  providedIn: 'root',
})
export class CepProviderService {
  getCepFunction(): typeof cepFn {
    return cep;
  }
}
